import ECommerceContainer from "../../../components/general/dashboards/eCommerce";

const ECommerce = () => {
  return <ECommerceContainer />;
};

export default ECommerce;
